export const isTelegramWebApp = () => {
  const isTelegram = false;
  try {
    if (typeof window === 'undefined')  {
      isTelegram = false;
    }
      

    // Primary working check (your environment)
    if (window.TelegramWebviewProxy && typeof window.TelegramWebviewProxy !== 'undefined' && typeof window.TelegramWebviewProxy !== undefined) {
      isTelegram = true;
    } 

    // Official Telegram WebApp object
    if (window.Telegram && typeof window.Telegram.WebApp !== 'undefined') {
      isTelegram = true;
    }
    // Other wrapper globals
    if (typeof window.TelegramWebApp !== 'undefined' || typeof window.TelegramWebView !== 'undefined') {
      isTelegram = true;
    }
    // UA/referrer/URL heuristics
    const ua = (navigator && navigator.userAgent) ? String(navigator.userAgent).toLowerCase() : '';
    if (ua.includes('telegram')) {
      isTelegram = true;
    }
    const ref = (document && document.referrer) ? String(document.referrer).toLowerCase() : '';
    if ((ref.includes('t.me') || ref.includes('telegram')) && !ref.toLowerCase().includes('/telegramapp') && !ref.toLowerCase().includes('/telegrambot')) {
        isTelegram = true;
      }
    const qs = (window.location && window.location.search) ? String(window.location.search).toLowerCase() : '';
    if ((qs.includes('tgwebapp') || qs.includes('telegram')) && !ref.toLowerCase().includes('/telegramapp') && !ref.toLowerCase().includes('/telegrambot')) {
      isTelegram = true;
    }
    return isTelegram;
  } catch (e) {
    return false;
  }
};